/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItem_viewer$ref: FragmentReference;
export type PdpRespSimilarItem_viewer = {|
  +isEnabledDesignerConnection: ?boolean,
  +isSeoQuicklookEnabled: ?boolean,
  +isFavoritesEnabled: ?boolean,
  +$refType: PdpRespSimilarItem_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItem_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isEnabledDesignerConnection",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "postContactSellerDesignerConnection",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"postContactSellerDesignerConnection\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd5371ff221d9b97e414dc1c9651ff71f';
module.exports = node;
